{
    "NAME": "CallRecIntegration",
    "AddCallRecIntegrationTitle": "Ajouter l'intégration de l'enregistrement des appels",
    "ModifyCallRecIntegrationTitle": "Modifier l'intégration de l'enregistrement des appels",
    "TabGeneralTitle": "Général",
    "TabScopeAssignmentsTitle": "Affectation des champs d'application",
    "TabApiCommunicationsTitle": "Api Communications",
    "TabDubberCommunicationsTitle": "Dubber Communications",
    "IdentifierGUID": "(GUID) :",
    "IdentifierGUIDPlaceholder": "[Auto Assigné]",
    "IntegrationType": "Type d'intégration :",
    "IntegrationType_1": "[Type inconnu ou non spécifié]",
    "IntegrationType_2": "Dubber Corporation Limited",
    "ModifyCallRecIntegrationDescriptionFormLabel": "Description :",
    "DubberApiComSettingsLocationUrls": "Dubber Location URL :",
    "ApiComSettingsIPAddrOne": "Adresse IP 1 (MAIN) :",
    "ApiComSettingsIPAddrTwo": "Adresse IP 2 (SECONDAIRE) :",
    "ApiComSettingsAuthDetailsMainTitle": "Détails de l'authentification (MAIN)",
    "ApiComSettingsAuthDetailsMainUserName": "Nom d'utilisateur (MAIN) :",
    "ApiComSettingsAuthDetailsMainUserPassword": "Mot de passe (MAIN) :",
    "ApiComSettingsAuthDetailsSecondaryTitle": "Détails de l'authentification (SECONDAIRE) :",
    "ApiComSettingsAuthDetailsSecondaryUserName": "Nom d'utilisateur (secondaire) :",
    "ApiComSettingsAuthDetailsSecondaryUserPassword": "Mot de passe (secondaire) :",
    "ApiComSettingsApiParamOne": "Paramètre API 1 :",
    "ApiComSettingsApiParamTwo": "Paramètre API 2 :",
    "DubberComSettingsApiParamOne": "Nom du compte (TRAILING PART) :",
    "DubberComSettingsApiParamTWO": "Utilisateur du compte \/ E-MAIL (FACULTATIF) :",
    "DubberComSettingsTitle": "Paramètres de communication Dubber",
    "DubberComSettingsLocationURL": "Dubber Location URL :",
    "DubberComSettingsDevAuthTitle": "Authentification du développeur",
    "DubberComSettingsDevAuthUserName": "Nom d'utilisateur (clé MASHERYID) :",
    "DubberComSettingsDevAuthUserPassword": "Mot de passe (MASHERYID SECRET) :",
    "DubberComSettingsAccountApiAuthTitle": "Authentification de l'API du compte",
    "DubberComSettingsAccountApiAuthUserName": "Nom d'utilisateur (API AUTH ID) :",
    "DubberComSettingsAccountApiAuthUserPassword": "Mot de passe (API AUTH TOKEN) :",
    "DubberComSettingAccountName": "Nom du compte (partie terminale)",
    "DubberComSettingsAccountUserEmail": "Utilisateur du compte \/ Email (FACULTATIF)",
    "CallRecIntegrationAddModify_UnknownOrDeleted": "[Inconnu ou supprimé]",
    "CallRecIntegrationAddModify_ServerErrorTitle": "Erreurs de validation",
    "CallRecIntegrationAddModify_ValidationWarning": "Veillez à ce que tous les champs soient correctement remplis",
    "CallRecIntegrationAddModify_ButtonHelpLabel": "Aide ?",
    "CallRecIntegrationAddModify_ButtonSubmitLabel": "Économiser",
    "CallRecIntegrationAddModify_ButtonCancelLabel": "Annuler",
    "CallRecIntegrationAddModify_PromptMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues à la fermeture.",
    "CallRecIntegrationAddModify_PromptConfirm": "Oui",
    "CallRecIntegrationAddModify_PromptCancel": "Annuler",
    "Error_TestIntegration_Timeout": "L'ouverture de session de l'intégration des tests a été interrompue",
    "InputField_Change_Username": "[Changer le nom d'utilisateur]",
    "InputField_Change_Password": "[Changer le mot de passe]",
    "DubberComSettings_Parameters": "Paramètres",
    "DubberComSettings_TestIntegrationAuth": "Authentification de l'intégration des tests",
    "DubberSuccessfullIntegration": "Les paramètres de communication de l'intégration de l'enregistrement des appels fonctionnent correctement"
}